export const navigation = {
  english: {
    title: 'Navigation',
    sggsProject: 'Welcome to the Guru Granth Sahib Project',
    subTagLine: "Guru Fatih! Welcome to our site, which is dedicated to preserving and sharing the timeless wisdom of the Guru Granth Sahib. To make your journey through this repository seamless, here's a quick tutorial and guide.",
    theVision: 'How to Use the Site',
    visionParagraphOne:
      'Watch this brief video tutorial to get acquainted with the features and functionalities of our website. Learn how to explore the Guru Granth Sahib, access translations, and maximize our resources.',
    subTitle2:
      'Step-by-Step Navigation',
    subTitleContent1:
      'Homepage',
    subTitleContent2:
      'Dimensions',
    subTitleContent3:
      'Word Meanings',
    subTitleContent1Para:
      'Select the search icon from the home page to browse our entire collection of releases, or directly search for a Bani or composition by author, page number, keyword, or title using popular spellings.',
    subTitleContent2Para:
      'To learn about important information and background on any Bani, click the Introduction. You can navigate between sections to learn about the historical and musical dimensions of any Bani on the site.',
    subTitleContent3Para:
      'Click on any word in the Romanization section to learn its meaning, grammar, etymology, and any footnotes it may have.',

  },

  panjabi: {
    title: 'Navigation',
    sggsProject: 'Welcome to the Guru Granth Sahib Project',
    subTagLine: "Guru Fatih! Welcome to our site, which is dedicated to preserving and sharing the timeless wisdom of the Guru Granth Sahib. To make your journey through this repository seamless, here's a quick tutorial and guide.",
    theVision: 'How to Use the Site',
    visionParagraphOne:
      'Watch this brief video tutorial to get acquainted with the features and functionalities of our website. Learn how to explore the Guru Granth Sahib, access translations, and maximize our resources.',
    subTitle2:
      'Step-by-Step Navigation',
    subTitleContent1:
      'Homepage',
    subTitleContent2:
      'Dimensions',
    subTitleContent3:
      'Word Meanings',
    subTitleContent1Para:
      'Select the search icon from the home page to browse our entire collection of releases, or directly search for a Bani or composition by author, page number, keyword, or title using popular spellings.',
    subTitleContent2Para:
      'To learn about important information and background on any Bani, click the Introduction. You can navigate between sections to learn about the historical and musical dimensions of any Bani on the site.',
    subTitleContent3Para:
      'Click on any word in the Romanization section to learn its meaning, grammar, etymology, and any footnotes it may have.',

  },
};
